var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "move_svg__Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".move_svg__st0{fill:#666}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "move_svg__move"
  }, /*#__PURE__*/React.createElement("path", {
    className: "move_svg__st0",
    d: "M26 28v6h4l-6 6-6-6h4v-6zM22 20v-6h-4l6-6 6 6h-4v6zM20 26h-6v4l-6-6 6-6v4h6zM28 22h6v-4l6 6-6 6v-4h-6z"
  }))));
};
export default SvgMove;